(function () {
  'use strict';

  var API_URL = window.PERDE_API_URL || '';

  function log(msg, data) {
    if (data !== undefined) {
      console.log('[PerdeCheckout] ' + msg, data);
    } else {
      console.log('[PerdeCheckout] ' + msg);
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], a[href*="checkouts"]'
    );
    if (!target) return;

    // Only intercept checkout buttons inside Horizon cart components or explicitly marked elements.
    // Prevents false positives on any storefront link containing "/checkout" or "/checkouts" in its href.
    var isCartCheckout = target.closest('cart-drawer-component, cart-items-component, [data-perde-checkout]');
    if (!isCartCheckout) return;

    // Don't intercept if we have no API configured
    if (!API_URL) {
      log('no API_URL — falling through to normal checkout');
      return;
    }

    // Prevent default navigation while we query the server
    e.preventDefault();
    e.stopImmediatePropagation();

    var originalText = target.textContent;
    var originalHref = target.href || '/checkout';
    target.disabled = true;
    if (target.tagName === 'A' || target.tagName === 'BUTTON') {
      target.textContent = 'Hazırlanıyor…';
    }

    log('intercepted checkout click');

    // Step 1: get cart token
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count || cart.item_count === 0) {
          log('cart empty — falling through');
          if (window.posthog) posthog.capture('checkout_fallthrough', { reason: 'cart_empty' });
          window.location.href = originalHref;
          return;
        }

        var cartToken = cart.token;
        if (!cartToken) {
          log('no cart token — falling through');
          window.location.href = originalHref;
          return;
        }

        log('cart token obtained', { token: cartToken, items: cart.item_count });

        // Step 2: ask server for draft order checkout URL
        return fetch(API_URL + '/api/checkout/complete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cartToken: cartToken })
        })
          .then(function (res) {
            if (res.status === 404) {
              // No configured items in DB — fall through to normal Shopify checkout
              log('NO_ITEMS from server — falling through to normal checkout');
              if (window.posthog) posthog.capture('checkout_fallthrough', { reason: 'no_configured_items', cart_token: cartToken });
              window.location.href = originalHref;
              return;
            }
            if (!res.ok) {
              log('server error — falling through', { status: res.status });
              if (window.posthog) posthog.capture('checkout_fallthrough', { reason: 'server_error', status: res.status, cart_token: cartToken });
              window.location.href = originalHref;
              return;
            }
            return res.json().then(function (data) {
              if (data && data.checkoutUrl) {
                log('redirecting to draft order checkout', { url: data.checkoutUrl.substring(0, 60) });
                if (window.posthog) {
                  posthog.capture('checkout_started', {
                    cart_token: cartToken,
                    item_count: cart.item_count,
                    total_price: data.totalPrice,
                  });
                }
                // Cart is NOT cleared here — it stays intact so users can return if they abandon checkout.
                // The cart is cleared by the order status page script after confirmed payment.
                window.location.href = data.checkoutUrl;
              } else {
                log('no checkoutUrl in response — falling through');
                if (window.posthog) posthog.capture('checkout_fallthrough', { reason: 'no_checkout_url', cart_token: cartToken });
                window.location.href = originalHref;
              }
            });
          });
      })
      .catch(function (err) {
        log('error — falling through', { error: err.message });
        // Restore button and fall through to normal checkout
        target.disabled = false;
        if (target.tagName === 'A' || target.tagName === 'BUTTON') {
          target.textContent = originalText;
        }
        window.location.href = originalHref;
      });
  }, true); // capture phase — fires before any other click handlers

  log('loaded', { apiUrl: API_URL ? API_URL : 'NOT SET' });
})();
